import { select } from "@/utils";

export interface ExpandableSettings {
    toggleButtonClass: string;
    contentContainerClass?: string;
    expandedClass: string;
}

export interface ExpandableDelegate {
    transitionToExpandedState(content: Expandable, expanded: boolean): void;
}

export class Expandable {
    private toggleBtn!: HTMLElement;
    private contentContainer?: HTMLElement;
    private delegate?: ExpandableDelegate;

    constructor(
        public readonly element: HTMLElement,
        private readonly settings: ExpandableSettings,
    ) {}

    get expanded(): boolean {
        return this.element.classList.contains(this.settings.expandedClass);
    }

    set expanded(expanded: boolean) {
        this.element.classList.toggle(this.settings.expandedClass, expanded);
        this.toggleBtn.setAttribute("aria-expanded", expanded ? "true" : "false");
    }

    get content(): HTMLElement | undefined {
        return this.contentContainer;
    }

    connect(delegate?: ExpandableDelegate): void {
        this.delegate = delegate;
        this.toggleBtn = select(this.element, { class: this.settings.toggleButtonClass, required: true });
        const contentClass = this.settings.contentContainerClass;
        if (contentClass) {
            this.contentContainer = select(this.element, { class: contentClass, required: true });
        }
        this.toggleBtn.addEventListener("click", this.toggle);
    }

    disconnect(): void {
        this.delegate = undefined;
        this.toggleBtn.removeEventListener("click", this.toggle);
    }

    toggle = (): void => {
        if (this.delegate) {
            this.delegate.transitionToExpandedState(this, !this.expanded);
        } else {
            this.expanded = !this.expanded;
        }
    };
}
